// extracted by mini-css-extract-plugin
export default {"btn-add-keybox":"KeyboxManagement_btn-add-keybox__Ngmy2","pr-22":"KeyboxManagement_pr-22__-1ro-"};